import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/qbd-pharma-connect")({
  head: () => buildRouteHead("/en/qbd-pharma-connect", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/qbdpharmaconnect", replace: true });
  },
});
